import styles from "./styles.module.scss"
import cn from "clsx"
import type { FC, HTMLAttributes } from "react"


interface HeadingProps
extends HTMLAttributes<HTMLHeadingElement> {
  size?: 'small' | 'regular',
  number?: number,
}

export const Heading: FC<HeadingProps> = ({ 
  size = 'regular', number,
  className, ...rest 
}) => (
  <h2 {...rest} data-number={number && `${number.toString().padStart(2, '0')}.`}
  className={cn(styles.heading, styles[size], className)} />
)


interface SubHeadingProps
extends HTMLAttributes<HTMLHeadingElement> {
  number?: number,
}

export const SubHeading: FC<SubHeadingProps> = ({ 
  number,
  className, ...rest 
}) => (
  <p {...rest} data-number={number && `${number.toString().padStart(2, '0')}.`}
  className={cn(styles.subHeading, className)} />
)
